import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from "@azure/msal-react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

import { loginRequest } from "./authConfig.ts"
import AppRouter from "./components/AppRouter.tsx"
import LoginPrompt from "./components/LoginPrompt.tsx"

import type { PublicClientApplication } from "@azure/msal-browser"
// eslint-disable-next-line
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 30 * 60_000,
      refetchOnWindowFocus: false,
    },
  },
})

function App({ instance }: { instance: PublicClientApplication }) {
  const handleRedirect = () => {
    instance
      .loginRedirect({
        ...loginRequest,
        prompt: "create",
        redirectUri: "/",
        state: window.location.pathname,
      })
      .catch((error) => console.log(error))
  }

  return (
    <MsalProvider instance={instance}>
      <QueryClientProvider client={queryClient}>
        <AuthenticatedTemplate>
          <AppRouter />
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <LoginPrompt handleRedirect={handleRedirect} />
        </UnauthenticatedTemplate>
      </QueryClientProvider>
    </MsalProvider>
  )
}

export default App
